
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "feedback-public-submission-ui",
  currentProjectVersion: "static-1.31058",
  depVersions: {
  "feedback-public-submission-ui": "static-1.31058",
  "emoji-mart": "static-3.9",
  "feedback-schema": "static-1.55644",
  "head-dlb": "static-1.5330",
  "hs-test-utils": "static-1.8541",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11989",
  "I18n": "static-7.1715",
  "quartz": "static-1.7694",
  "quartz-config": "static-1.1472",
  "quartz-core": "static-1.6913",
  "react-dlb": "static-1.96",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.86",
  "reselect": "static-3.18",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1124",
  "enviro": "static-4.523",
  "feedback-shared-ui": "static-1.55631",
  "feedback-utils": "static-1.55635",
  "forms-embed-utils-lib": "static-1.4962",
  "forms-utils-lib": "static-1.13377",
  "foundations-assets": "static-1.5392",
  "foundations-components": "static-1.8789",
  "foundations-theming": "static-1.4992",
  "hub-http": "static-1.6708",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12296",
  "icons": "static-2.709",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4245",
  "raven": "static-3.6411",
  "react": "static-7.204",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17241",
  "react-select-plus": "static-1.120",
  "react-utils": "static-2.5681",
  "react-virtualized": "static-2.114",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.520",
  "tinymce-plugins": "static-1.58555",
  "transmute": "static-2.97",
  "ui-images": "static-2.1283",
  "UIComponents": "static-3.8935",
  "hs-promise-rejection-tracking": "static-1.6078",
  "PortalIdParser": "static-2.458",
  "raven-hubspot": "static-1.6718",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3971",
  "quartz-webpack": "static-1.3918",
  "foundations-theming-specialty": "static-1.2708",
  "property-description-translator": "static-1.4324",
  "HeadJS": "static-2.829",
  "framer-motion": "static-1.86",
  "hs-test-utils-bend-plugin": "static-1.3652",
  "msw": "static-1.105",
  "msw-config": "static-1.35",
  "testing-library": "static-1.167",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.237",
  "moment-timezone": "static-5.98",
  "jasmine": "static-4.4808",
  "jasmine-runner": "static-1.6955",
  "opentelemetry-fe-types": "static-1.294",
  "dispatcher": "static-1.150",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.913",
  "hubspotter-http": "static-1.4989",
  "mobile-manifest-mixins": "static-1.612",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.669",
  "quartz-auth": "static-1.1369",
  "quartz-head": "static-1.1359",
  "quartz-i18n": "static-1.1369",
  "quartz-routing": "static-1.1124",
  "quartz-test": "static-1.1369",
  "quartz-tracking": "static-1.1073",
  "trellis-components": "static-1.3177",
  "ui-fonts": "static-1.1251",
  "usage-tracker-container": "static-1.7814",
  "usage-tracker-core": "static-1.7674",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.390",
  "conversations-skeleton-state": "static-1.7621",
  "reference-resolvers": "static-1.8686",
  "sanitize-text": "static-1.8661",
  "PatternValidationJS": "static-1.3384",
  "ReduxMessenger": "static-2.10872",
  "outpost": "static-1.4632",
  "rpc-client-utils": "static-1.5168",
  "sanitize": "static-1.4973",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.5058",
  "floating-ui": "static-1.70",
  "hs-story-utils": "static-1.9930",
  "react-aria": "static-1.79",
  "react-create-root-preference": "static-1.111",
  "tanstack-table": "static-1.68",
  "trellis-assets": "static-1.3158",
  "bend-plugin-foundations-theming": "static-1.3475",
  "foundations-theming-base": "static-1.3977",
  "stylex": "static-1.48",
  "hs-locale-management": "static-1.416",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.201",
  "web-vitals": "static-1.21",
  "ai-components-ui-library": "static-1.10068",
  "atom": "static-1.5574",
  "codemirror": "static-5.108",
  "content-assistance-lib": "static-1.8460",
  "ContentUtils": "static-1.69534",
  "data-token-picker": "static-1.17175",
  "file-manager-components": "static-1.24882",
  "FileManagerCore": "static-1.40381",
  "FileManagerLib": "static-1.40522",
  "frontend-preferences-client": "static-1.8424",
  "hub-http-contrib": "static-1.3535",
  "interframe": "static-3.5246",
  "layout-dnd-components": "static-1.13266",
  "layout-dnd-utils": "static-1.12241",
  "property-translator": "static-1.5884",
  "react-codemirror": "static-1.11145",
  "react-colorpicker": "static-2.10711",
  "reference-resolvers-lite": "static-1.8616",
  "rich-text-lib": "static-1.20595",
  "tinymce-data": "static-1.41526",
  "tinymce-themes": "static-1.57411",
  "ui-addon-emoji-picker": "static-1.10366",
  "ui-addon-sales-email": "static-1.5706",
  "ui-brand-identity-lib": "static-1.17010",
  "bender-build-tools": "static-1.3617",
  "opentelemetry-web": "static-1.25",
  "hub-http-shared-msw-handlers": "static-1.10946",
  "hubspotter-http-shared-msw-handlers": "static-1.10944",
  "usage-tracker-session-replay": "static-1.5510",
  "base-ui": "static-1.31",
  "react-day-picker": "static-1.17",
  "tanstack-virtual": "static-1.45",
  "trellis-theming": "static-1.1518",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.578",
  "chirp-fetch": "static-1.2408",
  "stylex-utils": "static-1.182",
  "chatspot-core": "static-1.24036",
  "copilot-toolkit": "static-1.12198",
  "customer-data-objects-ui-components": "static-1.13539",
  "data-fetching-client": "static-1.10141",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5260",
  "ui-addon-video-player": "static-1.9126",
  "ui-coaching-tips": "static-1.29612",
  "usage-tracker": "static-1.7824",
  "cms-field-types": "static-1.5314",
  "content-icons-ui": "static-1.2483",
  "integrations-lib": "static-1.17484",
  "customer-data-objects": "static-1.8214",
  "apollo-dlb": "static-3.98",
  "apollo-link-hub-http": "static-2.5092",
  "apollo-stack-hubspot": "static-3.101",
  "breeze-engine-lib": "static-1.2263",
  "graphql": "static-1.95",
  "immer": "static-1.107",
  "immerable": "static-1.4646",
  "poll-commands": "static-1.3980",
  "ui-addon-iframeable": "static-1.9581",
  "video-components-external": "static-1.12491",
  "video-data-lib": "static-1.36149",
  "audio-components": "static-1.6610",
  "breeze-artifacts-sdk": "static-1.1075",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30100",
  "FileManagerImages": "static-1.38033",
  "foundations-components-legacy": "static-1.1814",
  "html-to-image": "static-1.67",
  "redux-toolkit": "static-1.84",
  "salesImages": "static-1.759",
  "ui-universal-auth": "static-1.9792",
  "urlinator": "static-1.5017",
  "video-components": "static-1.14493",
  "video-embed": "static-1.36983",
  "ts-schema": "static-1.4409",
  "ContentData": "static-1.69609",
  "layout-data-lib": "static-1.10566",
  "react-dnd-compat": "static-1.5111",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.2052",
  "external-options-client-types": "static-1.4453",
  "fast-json-stable-stringify": "static-1.4",
  "hs-promise-utils": "static-1.6094",
  "hs-resources": "static-1.687",
  "inbound-db-properties-service-client": "static-1.4165",
  "NamespacedHubStyle": "static-2.9382",
  "growth-onboarding-confetti": "static-1.3561",
  "SharedI18nStrings": "static-1.190",
  "ui-addon-i18n": "static-1.11648",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5932",
  "magpie-types": "static-1.5392",
  "simple-logging-lib": "static-1.3554",
  "avatar-components": "static-1.2991",
  "customer-data-ui-utilities": "static-1.10335",
  "growth-onboarding-feedback-components": "static-1.7083",
  "flux-actions": "static-1.383",
  "hubspot-apollo-client": "static-1.5385",
  "integrations-error-boundary-lib": "static-1.14899",
  "integrations-tracking-lib": "static-1.6126",
  "laboratory-lib": "static-3.7649",
  "native-integrations-shared-strings": "static-1.8264",
  "redux-observable": "static-1.81",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10783",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1241",
  "breeze-engine-core": "static-1.1541",
  "highlight.js": "static-1.92",
  "pulse": "static-1.1153",
  "navigation-messaging": "static-1.8545",
  "content-media-composition-data-lib": "static-1.13639",
  "content-media-compositions": "static-2.17646",
  "idb-keyval": "static-1.57",
  "media-bridge-lib": "static-1.19679",
  "nudge-client-utils": "static-1.3459",
  "custom-vendor-connection-lib": "static-1.356",
  "unified-auth-core-lib": "static-1.1588",
  "social-insights-client-types": "static-1.22974",
  "advanced-menus-core": "static-1.15857",
  "advanced-menus-lib": "static-1.12601",
  "ExportDialog": "static-6.10876",
  "ui-memberships-settings-lib": "static-1.35250",
  "conditional-properties-service-client": "static-1.4128",
  "crm-pipelines-api-client-types": "static-1.4458",
  "event-emitter": "static-1.1464",
  "fdsr-migration-layer": "static-1.515",
  "framework-builder-read-service-client": "static-1.4350",
  "inbound-db-meta-service-client": "static-1.3789",
  "multi-currency-client-types": "static-1.4023",
  "foundations-components-test-utils": "static-1.6272",
  "reactive-lib": "static-1.1223",
  "trellis-migration-context": "static-1.81",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.844",
  "universal-page-editor-lib": "static-1.3515",
  "bend-plugin-pulse": "static-1.656",
  "fast-json-patch": "static-1.76",
  "nav-meta": "static-1.30855",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3216",
  "nudge-renderer-utils": "static-1.3535",
  "onboarding-tours": "static-1.17428",
  "whisper-core-api": "static-1.7675",
  "fsm": "static-1.4260",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15856",
  "simple-menus-lib": "static-1.17373",
  "settings-ui-lib": "static-1.13030",
  "persist-promise": "static-1.4209",
  "crm-record-cards-client": "static-1.114",
  "crm-record-cards-service-types": "static-1.3876",
  "framework-data-schema-resolvers": "static-1.7396",
  "location-customization-utils-lib": "static-1.10470",
  "getting-started-shared-tasks": "static-1.19608",
  "growth-data-modal": "static-1.6170",
  "growth-onboarding-next-action-utils": "static-1.3029",
  "navigation-components": "static-1.19218",
  "nest": "static-1.739",
  "onboarding-tours-client": "static-1.5643",
  "onboarding-tours-utils": "static-1.1495",
  "ui-shepherd-tracker": "static-1.8164",
  "user-context": "static-1.5557",
  "react-flip-move": "static-1.85",
  "framework-data-schema-quick-fetch": "static-1.7301",
  "onboarding-data-sync-lib": "static-1.2875",
  "growth-onboarding-next-action-components": "static-1.3057",
  "user-context-client": "static-1.5011",
  "getting-started-shared-tasks-store": "static-1.18726",
  "InboxConnectUtils": "static-4.15886",
  "meetings-connect-utils-lib": "static-1.8123",
  "onboarding-scopes": "static-1.6956"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.31058",
  "emoji-mart": "/emoji-mart/static-3.9",
  "feedback-schema": "/feedback-schema/static-1.55644",
  "head-dlb": "/head-dlb/static-1.5330",
  "hs-test-utils": "/hs-test-utils/static-1.8541",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11989",
  "I18n": "/I18n/static-7.1715",
  "quartz": "/quartz/static-1.7694",
  "quartz-config": "/quartz-config/static-1.1472",
  "quartz-core": "/quartz-core/static-1.6913",
  "react-dlb": "/react-dlb/static-1.96",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.86",
  "reselect": "/reselect/static-3.18",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1124",
  "enviro": "/enviro/static-4.523",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55631",
  "feedback-utils": "/feedback-utils/static-1.55635",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4962",
  "forms-utils-lib": "/forms-utils-lib/static-1.13377",
  "foundations-assets": "/foundations-assets/static-1.5392",
  "foundations-components": "/foundations-components/static-1.8789",
  "foundations-theming": "/foundations-theming/static-1.4992",
  "hub-http": "/hub-http/static-1.6708",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12296",
  "icons": "/icons/static-2.709",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4245",
  "raven": "/raven/static-3.6411",
  "react": "/react/static-7.204",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17241",
  "react-select-plus": "/react-select-plus/static-1.120",
  "react-utils": "/react-utils/static-2.5681",
  "react-virtualized": "/react-virtualized/static-2.114",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.520",
  "tinymce-plugins": "/tinymce-plugins/static-1.58555",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1283",
  "UIComponents": "/UIComponents/static-3.8935",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6078",
  "PortalIdParser": "/PortalIdParser/static-2.458",
  "raven-hubspot": "/raven-hubspot/static-1.6718",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3971",
  "quartz-webpack": "/quartz-webpack/static-1.3918",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2708",
  "property-description-translator": "/property-description-translator/static-1.4324",
  "HeadJS": "/HeadJS/static-2.829",
  "framer-motion": "/framer-motion/static-1.86",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3652",
  "msw": "/msw/static-1.105",
  "msw-config": "/msw-config/static-1.35",
  "testing-library": "/testing-library/static-1.167",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.237",
  "moment-timezone": "/moment-timezone/static-5.98",
  "jasmine": "/jasmine/static-4.4808",
  "jasmine-runner": "/jasmine-runner/static-1.6955",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.294",
  "dispatcher": "/dispatcher/static-1.150",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.913",
  "hubspotter-http": "/hubspotter-http/static-1.4989",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.612",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.669",
  "quartz-auth": "/quartz-auth/static-1.1369",
  "quartz-head": "/quartz-head/static-1.1359",
  "quartz-i18n": "/quartz-i18n/static-1.1369",
  "quartz-routing": "/quartz-routing/static-1.1124",
  "quartz-test": "/quartz-test/static-1.1369",
  "quartz-tracking": "/quartz-tracking/static-1.1073",
  "trellis-components": "/trellis-components/static-1.3177",
  "ui-fonts": "/ui-fonts/static-1.1251",
  "usage-tracker-container": "/usage-tracker-container/static-1.7814",
  "usage-tracker-core": "/usage-tracker-core/static-1.7674",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.390",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7621",
  "reference-resolvers": "/reference-resolvers/static-1.8686",
  "sanitize-text": "/sanitize-text/static-1.8661",
  "PatternValidationJS": "/PatternValidationJS/static-1.3384",
  "ReduxMessenger": "/ReduxMessenger/static-2.10872",
  "outpost": "/outpost/static-1.4632",
  "rpc-client-utils": "/rpc-client-utils/static-1.5168",
  "sanitize": "/sanitize/static-1.4973",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5058",
  "floating-ui": "/floating-ui/static-1.70",
  "hs-story-utils": "/hs-story-utils/static-1.9930",
  "react-aria": "/react-aria/static-1.79",
  "react-create-root-preference": "/react-create-root-preference/static-1.111",
  "tanstack-table": "/tanstack-table/static-1.68",
  "trellis-assets": "/trellis-assets/static-1.3158",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3475",
  "foundations-theming-base": "/foundations-theming-base/static-1.3977",
  "stylex": "/stylex/static-1.48",
  "hs-locale-management": "/hs-locale-management/static-1.416",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.201",
  "web-vitals": "/web-vitals/static-1.21",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10068",
  "atom": "/atom/static-1.5574",
  "codemirror": "/codemirror/static-5.108",
  "content-assistance-lib": "/content-assistance-lib/static-1.8460",
  "ContentUtils": "/ContentUtils/static-1.69534",
  "data-token-picker": "/data-token-picker/static-1.17175",
  "file-manager-components": "/file-manager-components/static-1.24882",
  "FileManagerCore": "/FileManagerCore/static-1.40381",
  "FileManagerLib": "/FileManagerLib/static-1.40522",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8424",
  "hub-http-contrib": "/hub-http-contrib/static-1.3535",
  "interframe": "/interframe/static-3.5246",
  "layout-dnd-components": "/layout-dnd-components/static-1.13266",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12241",
  "property-translator": "/property-translator/static-1.5884",
  "react-codemirror": "/react-codemirror/static-1.11145",
  "react-colorpicker": "/react-colorpicker/static-2.10711",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8616",
  "rich-text-lib": "/rich-text-lib/static-1.20595",
  "tinymce-data": "/tinymce-data/static-1.41526",
  "tinymce-themes": "/tinymce-themes/static-1.57411",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10366",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5706",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17010",
  "bender-build-tools": "/bender-build-tools/static-1.3617",
  "opentelemetry-web": "/opentelemetry-web/static-1.25",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10946",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10944",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5510",
  "base-ui": "/base-ui/static-1.31",
  "react-day-picker": "/react-day-picker/static-1.17",
  "tanstack-virtual": "/tanstack-virtual/static-1.45",
  "trellis-theming": "/trellis-theming/static-1.1518",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.578",
  "chirp-fetch": "/chirp-fetch/static-1.2408",
  "stylex-utils": "/stylex-utils/static-1.182",
  "chatspot-core": "/chatspot-core/static-1.24036",
  "copilot-toolkit": "/copilot-toolkit/static-1.12198",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13539",
  "data-fetching-client": "/data-fetching-client/static-1.10141",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5260",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9126",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29612",
  "usage-tracker": "/usage-tracker/static-1.7824",
  "cms-field-types": "/cms-field-types/static-1.5314",
  "content-icons-ui": "/content-icons-ui/static-1.2483",
  "integrations-lib": "/integrations-lib/static-1.17484",
  "customer-data-objects": "/customer-data-objects/static-1.8214",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5092",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.101",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2263",
  "graphql": "/graphql/static-1.95",
  "immer": "/immer/static-1.107",
  "immerable": "/immerable/static-1.4646",
  "poll-commands": "/poll-commands/static-1.3980",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9581",
  "video-components-external": "/video-components-external/static-1.12491",
  "video-data-lib": "/video-data-lib/static-1.36149",
  "audio-components": "/audio-components/static-1.6610",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1075",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30100",
  "FileManagerImages": "/FileManagerImages/static-1.38033",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1814",
  "html-to-image": "/html-to-image/static-1.67",
  "redux-toolkit": "/redux-toolkit/static-1.84",
  "salesImages": "/salesImages/static-1.759",
  "ui-universal-auth": "/ui-universal-auth/static-1.9792",
  "urlinator": "/urlinator/static-1.5017",
  "video-components": "/video-components/static-1.14493",
  "video-embed": "/video-embed/static-1.36983",
  "ts-schema": "/ts-schema/static-1.4409",
  "ContentData": "/ContentData/static-1.69609",
  "layout-data-lib": "/layout-data-lib/static-1.10566",
  "react-dnd-compat": "/react-dnd-compat/static-1.5111",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.2052",
  "external-options-client-types": "/external-options-client-types/static-1.4453",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "hs-promise-utils": "/hs-promise-utils/static-1.6094",
  "hs-resources": "/hs-resources/static-1.687",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4165",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9382",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3561",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11648",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5932",
  "magpie-types": "/magpie-types/static-1.5392",
  "simple-logging-lib": "/simple-logging-lib/static-1.3554",
  "avatar-components": "/avatar-components/static-1.2991",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10335",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7083",
  "flux-actions": "/flux-actions/static-1.383",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5385",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14899",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6126",
  "laboratory-lib": "/laboratory-lib/static-3.7649",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8264",
  "redux-observable": "/redux-observable/static-1.81",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10783",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1241",
  "breeze-engine-core": "/breeze-engine-core/static-1.1541",
  "highlight.js": "/highlight.js/static-1.92",
  "pulse": "/pulse/static-1.1153",
  "navigation-messaging": "/navigation-messaging/static-1.8545",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13639",
  "content-media-compositions": "/content-media-compositions/static-2.17646",
  "idb-keyval": "/idb-keyval/static-1.57",
  "media-bridge-lib": "/media-bridge-lib/static-1.19679",
  "nudge-client-utils": "/nudge-client-utils/static-1.3459",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.356",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1588",
  "social-insights-client-types": "/social-insights-client-types/static-1.22974",
  "advanced-menus-core": "/advanced-menus-core/static-1.15857",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12601",
  "ExportDialog": "/ExportDialog/static-6.10876",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35250",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4128",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4458",
  "event-emitter": "/event-emitter/static-1.1464",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.515",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4350",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3789",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4023",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6272",
  "reactive-lib": "/reactive-lib/static-1.1223",
  "trellis-migration-context": "/trellis-migration-context/static-1.81",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.844",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3515",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.656",
  "fast-json-patch": "/fast-json-patch/static-1.76",
  "nav-meta": "/nav-meta/static-1.30855",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3216",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3535",
  "onboarding-tours": "/onboarding-tours/static-1.17428",
  "whisper-core-api": "/whisper-core-api/static-1.7675",
  "fsm": "/fsm/static-1.4260",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15856",
  "simple-menus-lib": "/simple-menus-lib/static-1.17373",
  "settings-ui-lib": "/settings-ui-lib/static-1.13030",
  "persist-promise": "/persist-promise/static-1.4209",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.114",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3876",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7396",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10470",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19608",
  "growth-data-modal": "/growth-data-modal/static-1.6170",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3029",
  "navigation-components": "/navigation-components/static-1.19218",
  "nest": "/nest/static-1.739",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5643",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1495",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8164",
  "user-context": "/user-context/static-1.5557",
  "react-flip-move": "/react-flip-move/static-1.85",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7301",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2875",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3057",
  "user-context-client": "/user-context-client/static-1.5011",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18726",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15886",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8123",
  "onboarding-scopes": "/onboarding-scopes/static-1.6956"
}
};
